import { useEffect, useMemo, useRef, useState } from 'react';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { getMyInfo, getStoreAdmin, getXUserAgent } from 'utils/storages';
import { getValidToken } from 'utils/auth';

const getHeaders = async () => {
  const token = await getValidToken();
  const meInfo = getMyInfo();
  const storeAdmin = getStoreAdmin();
  return {
    Accept: 'text/event-stream',
    Authorization: `Bearer ${token}`,
    'X-User-Agent': getXUserAgent(),
    'X-Store-gsid': meInfo?.sid || storeAdmin?.said
  };
};

export const useQuerySubscription = (queryKey: any, url: string) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const eventSourceRef = useRef<any>(null);
  // getValidToken await 중 언마운트/재구독되면 뒤늦게 연결이 생기지 않도록 가드
  const cancelledRef = useRef(false);

  const connectSSE = async () => {
    setLoading(true);
    const headers = await getHeaders();
    if (cancelledRef.current) return;
    eventSourceRef.current?.close();
    const newEventSource = new EventSourcePolyfill(url, {
      headers,
      withCredentials: false
    });
    eventSourceRef.current = newEventSource;
    newEventSource.addEventListener('update', (event) => {
      if (event?.data) {
        setData(JSON.parse(event.data));
        setLoading(false);
        newEventSource.close();
      }
    });
    newEventSource.onerror = (err) => {
      setError(err);
      setLoading(false);
      newEventSource.close();
    };
  };

  useEffect(() => {
    if (!queryKey) {
      setData(null);
      setError(null);
      return;
    }
    cancelledRef.current = false;
    connectSSE();
    // eslint-disable-next-line consistent-return
    return () => {
      cancelledRef.current = true;
      eventSourceRef.current?.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryKey, url]);

  return useMemo(() => {
    return { data, error, loading, refetch: connectSSE };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, loading]);
};
